import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../contexts/ThemeContext";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as TrashIcon } from "../../../../assets/settingPage/trash.svg";
import { ReactComponent as TrashIconDark } from "../../../../assets/settingPage/trash-dark.svg";
import { ReactComponent as DownArrow } from "../../../../assets/settingPage/arrow-down.svg";
import { ReactComponent as DownArrowDark } from "../../../../assets/settingPage/arrow-down-dark.svg";

import { ReactComponent as ImagePlceHolder } from "../../../../assets/settingPage/profilePlacholder.svg";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { updateAccountDetail } from "../../../../redux/slices/user/userSlice";
import {
  updateProfilePic,
  resetUser,
} from "../../../../redux/slices/auth/authSlice";
import {
  resetUser as userReset,
  viewUser,
} from "../../../../redux/slices/user/userSlice";
import { toast } from "react-hot-toast";
import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import useLocales from "../../../../hooks/useLocales";
import MobileBottomLogoutBtn from "../../../../components/dashboard/MobileBottomLogoutBtn";
import { Helmet } from "react-helmet";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import useSettings from "../../../../hooks/useSettings";

const accTypes = ["bussiness", "personal"];

const Account = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const navigate = useNavigate();
  const { setActiveSettingSubNav } = useStateContext();
  const [selectedAccType, setSelectedAccType] = useState(null);
  const [selectAccTypeDropDown, setSelectAccTypeDropDown] = useState(false);
  const [subLoading, setSubLoading] = useState(false);

  const ImageUrl = process.env.REACT_APP_API_URL;

  const schema = yup.object().shape({
    first_name: yup
      .string()
      .test(
        "required",
        `${translate("descriptions.firstName_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("descriptions.firstName_required")}`),
    last_name: yup
      .string()
      .test(
        "required",
        `${translate("front_end_pages.contact.last_name_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("front_end_pages.contact.last_name_required")}`),
    email: yup
      .string()
      .email(`${translate("contact.valid")}`)
      .required(`${translate("descriptions.email_required")}`),
    accountType: yup
      .string()
      .required(`${translate("addBlock.account_type_required")}`),
    country: yup
      .string()
      .test(
        "required",
        `${translate("addBlock.country_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("addBlock.country_required")}`),
    state_region: yup
      .string()
      .test(
        "required",
        `${translate("addBlock.State_region_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("addBlock.State_region_required")}`),
    city: yup
      .string()
      .test(
        "required",
        `${translate("addBlock.city_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("addBlock.city_required")}`),
    zipCode: yup
      .string()
      .test(
        "required",
        `${translate("addBlock.zip_required")}`,
        (val) => !!val.trim()
      )
      .required(`${translate("addBlock.zip_required")}`),
  });

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  // getting User detail
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  // profile image upload functions
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const [file, setFile] = useState(null);
  const [uploadImagePending, setUploadImagePending] = useState(false);
  const [deleteImagePending, setDeleteImagePending] = useState(false);
  const fileChangeHandler = (e) => {
    if (e.target.files?.[0].size > 375000) {
      toast.error(`${translate("image_smaller_than_3MB")}`);
    } else {
      setFile(e.target.files?.[0]);
    }
  };
  const updateImage = async (file) => {
    if (file) {
      setUploadImagePending(true);
      const data = {
        picture: file,
        userId: userId,
      };
      await dispatch(updateProfilePic(data));
      dispatch(resetUser());
      setUploadImagePending(false);
    } else {
      toast.error(`${translate("addBlock.please_select_picture")}`);
    }
  };
  const removeImage = async () => {
    setDeleteImagePending(true);
    if (file) {
      setFile(null);
    } else if (user_data?.profile_image) {
      const data = {
        picture: "",
        userId: userId,
      };
      await dispatch(updateProfilePic(data));
      await dispatch(resetUser());
      await setFile(null);
      if (user) {
        await dispatch(viewUser(user.userid)).then(() => {
          dispatch(userReset());
        });
      }
    } else {
      setDeleteImagePending(false);
      return;
    }
    setDeleteImagePending(false);
  };

  const { isError, isSuccess, isLoading } = useSelector((state) => state?.user);

  const { status, message } = useSelector(
    (state) => state?.user?.updateProfilePicData
  );

  useEffect(() => {
    if (status === "Success" && isSuccess) {
      toast.success(message);
      dispatch(viewUser(userId)).then(() => {
        dispatch(userReset());
        setFile(null);
      });
    }
    if (isError) {
      navigate("/500");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  //  form submit handler
  const saveAccountDetail = async (e) => {
    setSubLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));

    const userId = user.userid;
    if (!selectedAccType) {
      toast.error("Please select Account Type");
      return;
    }
    const data = {
      firstName: e.first_name,
      lastName: e.last_name,
      email: e.email,

      accountType: e.accountType,
      country: e.country,
      province: e.state_region,
      city: e.city,
      zipCode: e.zipCode,
      userId: userId,
    };
    await dispatch(updateAccountDetail(data));
    setSubLoading(false);
  };

  // update account details response
  const {
    profileStateError,
    profileStateSuccess,
    profileStateLoading,
    profileState,
    profileStateErrorMsg,
  } = useSelector((state) => state?.adminUser);
  const { status: statusProfileState, message: messageProfileState } =
    useSelector((state) => state?.adminUser?.profileState);

  useEffect(() => {
    if (statusProfileState === "Success" && profileStateSuccess) {
      toast.success(messageProfileState);
      dispatch(viewUser(userId));
      dispatch(userReset());
    } else if (statusProfileState === "failed" && profileStateSuccess) {
      toast.error(messageProfileState);
    }
    if (profileStateError) {
      toast.error(profileStateErrorMsg);
    }
    dispatch(userReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileStateLoading, profileState]);

  //  default values for profile
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  const userBilling = useSelector(
    (state) => state?.adminUser?.viewUserData?.userBilling
  );
  useEffect(() => {
    setValue("email", user_data?.email);
    setValue("first_name", user_data?.firstName);
    setValue("last_name", user_data?.lastName);
    if (
      userBilling?.accountType === "bussiness" ||
      userBilling?.accountType === "personal"
    ) {
      setSelectedAccType(userBilling?.accountType);
      setValue("accountType", userBilling?.accountType);
    }
    setValue("city", userBilling?.city);
    setValue("state_region", userBilling?.province);
    setValue("country", userBilling?.country);
    setValue("zipCode", userBilling?.zip);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_data, userBilling]);

  useEffect(() => {
    setActiveSettingSubNav("account");
    return () => {
      setActiveSettingSubNav(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Account Setting | Bil.Bio</title>
        <meta property="og:title" content="Account Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="mt-10 mb-10 md:hidden ">
        <Link className="flex items-center gap-3" to={"/dashboard/setting"}>
          <div className="flex items-center justify-center ">
            {darkMode ? (
              <LeftArrowDark
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {translate("addBlock.account")}
          </h6>
        </Link>
      </div>
      <div className="w-full bg-white  dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
        <div className="min-h-[calc(100vh_-_285px)] flex flex-col justify-between ">
          <div>
            <h1 className="text-small1_bold lg:text-custom_h6 dark:text-color_v1_dark">
              {translate("addBlock.account_")}
            </h1>
            <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-font_dark_color">
              {translate("addBlock.update_your_page_name")}
            </p>
            <hr className="mt-4 lg:mt-5 dark:border-color_dark" />
            <div>
              <div>
                <p className="mt-6 lg:mt-10 text-small1_bold lg:text-body_copy1_b dark:text-color_v1_dark">
                  {translate("avatar")}
                </p>
                <div className="flex mt-5 lg:mt-[25px] items-center gap-4 lg:gap-[30px]">
                  {file ? (
                    <div className="relative flex items-center">
                      <label htmlFor="picture">
                        <div className="absolute inset-0 z-20 opacity-0 hover:opacity-60 bg-[#D9D9D9] border-heading_color border-dashed border flex justify-center items-center rounded-full cursor-pointer h-[70px] lg:h-[100px] w-[70px] lg:w-[100px]">
                          <ImagePlceHolder />
                        </div>
                        <div className="relative rounded-full cursor-pointer bg-light_bg_v4">
                          <img
                            className="h-[70px] max-h-[70px] lg:h-[100px] lg:max-h-[100px] max-w-[70px] w-[70px] lg:max-w-[100px] lg:w-[100px] p-[1px] object-cover rounded-full"
                            src={URL.createObjectURL(file)}
                            alt="..."
                          />
                        </div>
                        <input
                          id="picture"
                          type="file"
                          onChange={(e) => fileChangeHandler(e)}
                          accept="image/*"
                          className="hidden"
                        />
                      </label>
                    </div>
                  ) : user_data?.profile_image ? (
                    <div className="relative flex items-center">
                      <label htmlFor="picture">
                        <div className="absolute inset-0 z-20 opacity-0 hover:opacity-60 bg-[#D9D9D9] border-heading_color border-dashed border flex justify-center items-center rounded-full cursor-pointer h-[70px] lg:h-[100px] w-[70px] lg:w-[100px]">
                          <ImagePlceHolder />
                        </div>
                        <div className="z-10 rounded-full cursor-pointer bg-light_bg_v4">
                          <img
                            className="h-[70px] max-h-[70px] lg:h-[100px] lg:max-h-[100px] max-w-[70px] w-[70px] lg:max-w-[100px] lg:w-[100px] p-[1px] object-cover rounded-full"
                            src={`${ImageUrl}/profile/${user_data?.profile_image}`}
                            alt="..."
                          />
                        </div>
                        <input
                          id="picture"
                          type="file"
                          onChange={(e) => fileChangeHandler(e)}
                          accept="image/*"
                          className="hidden"
                        />
                      </label>
                    </div>
                  ) : (
                    <label htmlFor="picture">
                      <div className="bg-[#D9D9D9] border-heading_color border-dashed border flex justify-center items-center rounded-full cursor-pointer h-[70px] lg:h-[100px] w-[70px] lg:w-[100px]">
                        <ImagePlceHolder />
                      </div>
                      <input
                        id="picture"
                        type="file"
                        onChange={(e) => fileChangeHandler(e)}
                        accept="image/*"
                        className="hidden"
                      />
                    </label>
                  )}

                  {/*<img
                      className="h-[70px] lg:h-[100px] w-[70px] lg:w-[100px] object-cover"
                      src={DummyProfilePic}
                      alt="..."
                  />*/}

                  <div>
                    <div className="flex items-center gap-3 lg:gap-[15px]">
                      <button
                        onClick={() => updateImage(file)}
                        className={`rounded-full p-[6px] lg:p-[9px] bg-main_color text-white text-small3_b lg:text-small2_b ${
                          uploadImagePending
                            ? "opacity-70 px-[40px] lg:px-[46px]"
                            : "px-[22px] lg:px-[26px]"
                        }`}
                      >
                        {uploadImagePending ? (
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                        ) : (
                          `${translate("addBlock.upload")}`
                        )}
                      </button>
                      <button
                        disabled={deleteImagePending}
                        onClick={() => removeImage()}
                        className={`rounded-full bg-transparent text-body_copy1_color dark:text-color_v1_dark text-small3_b lg:text-small2_b flex items-center gap-[6px] lg:gap-2 cursor-pointer ${
                          deleteImagePending ? "opacity-70" : ""
                        }`}
                      >
                        {translate("addBlock.remove")}
                        {deleteImagePending ? (
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 text-dark_bg_v3 dark:text-color_v1_dark animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#B5B4BB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                        ) : darkMode ? (
                          <TrashIconDark width={15} height={15} />
                        ) : (
                          <TrashIcon width={15} height={15} />
                        )}
                      </button>
                    </div>
                    <div className="mt-2 lg:mt-[15px] text-[10px] lg:text-small3 text-font_light_color dark:text-font_dark_color">
                      *{translate("addBlock.image_size_should_be_3mb")}
                    </div>
                  </div>
                </div>
              </div>
              <form onSubmit={handleSubmit((data) => saveAccountDetail(data))}>
                <div>
                  <div className="mt-10 lg:mt-[50px]">
                    <p className="text-dark_bg_v1 text-small1_bold md:text-body_copy1_b dark:text-color_v1_dark">
                      {translate("addBlock.personal_details")}
                    </p>
                    <div className="grid gap-5 lg:gap-[30px] grid-cols-1 mt-6 lg:mt-5 lg:grid-cols-2">
                      <div>
                        <label
                          htmlFor="first_name"
                          className="block lg-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("firstName")}
                        </label>
                        <input
                          type="text"
                          {...register("first_name", {
                            required: `${translate("firstName_required")}`,
                            validate: {
                              matchPattern: (v) =>
                                /^[a-zA-Z]+$/.test(v) ||
                                `${translate(
                                  "addBlock.first_name_must_be_valid"
                                )}`,
                              maxLength: (v) =>
                                v.length <= 20 ||
                                `${translate(
                                  "addBlock.first_name_must_be_20_characters"
                                )}`,
                            },
                          })}
                          id="first_name"
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.first_name
                              ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate(
                            "front_end_pages.contact.enter_first_name"
                          )}
                        />
                        {errors?.first_name && (
                          <small className="text-state_color_error text-small3">
                            {errors?.first_name.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="last_name"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("front_end_pages.contact.last_name")}
                        </label>
                        <input
                          type="text"
                          {...register("last_name", {
                            required: `${translate(
                              "front_end_pages.contact.last_name_required"
                            )}`,
                          })}
                          id="last_name"
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.last_name
                              ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate(
                            "front_end_pages.contact.enter_last_name"
                          )}
                        />
                        {errors?.last_name && (
                          <small className="text-state_color_error text-small3">
                            {errors?.last_name.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="email"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("email_address")}
                        </label>
                        <input
                          type="email"
                          {...register("email", {
                            required: `${translate(
                              "descriptions.email_required"
                            )}`,
                            validate: {
                              maxLength: (v) =>
                                v.length <= 50 ||
                                `${translate(
                                  "addBlock.email_should_be_50_characters"
                                )}`,
                              matchPattern: (v) =>
                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                  v
                                ) ||
                                `${translate(
                                  "addBlock.email_address_must_be_valid"
                                )}`,
                            },
                          })}
                          id="email"
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.email
                              ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("auth.enter_page_email")}
                        />
                        {errors?.email && (
                          <small className="text-state_color_error text-small3">
                            {errors?.email.message}
                          </small>
                        )}
                      </div>

                      <div>
                        <label
                          htmlFor="accountType"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color"
                        >
                          {translate("addBlock.account")}
                          {translate("descriptions.type")}
                        </label>
                        <div className="relative ">
                          <div
                            onClick={() => {
                              setSelectAccTypeDropDown(!selectAccTypeDropDown);
                            }}
                            className={`bg-light_bg_v4 dark:bg-dark-secondary capitalize p-[13px] pl-[10px] lg:p-[15px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer ${
                              errors?.accountType
                                ? "border border-state_color_error text-state_color_error "
                                : "text-heading_color dark:text-color_v1_dark dark:border-color_dark dark:border"
                            }`}
                          >
                            {selectedAccType
                              ? selectedAccType
                              : `${translate("addBlock.choose_account_type")}`}
                            {darkMode ? <DownArrowDark /> : <DownArrow />}
                          </div>
                          {selectAccTypeDropDown && (
                            <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  dark:bg-dark-secondary rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                              {accTypes.map((item, i) => {
                                return (
                                  <div
                                    key={i}
                                    onClick={() => {
                                      setSelectedAccType(item);
                                      setSelectAccTypeDropDown(false);
                                      setValue("accountType", item);
                                      clearErrors("accountType");
                                    }}
                                    className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-primary dark:bg-dark-secondary rounded-md"
                                  >
                                    {item}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                        {errors?.accountType && (
                          <small className="text-state_color_error text-small3">
                            {errors?.accountType.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr className="mt-10 dark:border-color_dark" />
                  <div className="mt-[30px] lg:mt-10 ">
                    <p className="text-body_copy1_color dark:text-color_v1_dark text-small1_bold lg:text-body_copy1_b">
                      {translate("address")}
                    </p>
                    <div className="grid grid-cols-1 gap-5 lg:gap-[30px] mt-6 lg:mt-[15px] lg:grid-cols-2">
                      <div>
                        <label
                          htmlFor="country"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("label.country")}
                        </label>
                        <input
                          type="text"
                          id="country"
                          {...register("country")}
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.country
                              ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("addBlock.enter_country")}
                        />
                        {errors?.country && (
                          <small className="text-state_color_error text-small3">
                            {errors?.country.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="state_region"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("addBlock.state_region")}
                        </label>
                        <input
                          type="text"
                          id="state_region"
                          {...register("state_region")}
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.state_region
                              ? " border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("addBlock.enter_state_region")}
                        />
                        {errors?.state_region && (
                          <small className="text-state_color_error text-small3">
                            {errors?.state_region.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="city"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("city")}
                        </label>
                        <input
                          type="text"
                          id="city"
                          {...register("city")}
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.city
                              ? " border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("addBlock.enter_city")}
                        />
                        {errors?.city && (
                          <small className="text-state_color_error text-small3">
                            {errors?.city.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="zipCode"
                          className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("addBlock.zip_code")}
                        </label>
                        <input
                          type="number"
                          id="zipCode"
                          {...register("zipCode")}
                          className={`bg-transparent p-[13px] py-[5px] pl-[10px] lg:pl-[15px] lg:p-[15px] lg:py-[7px] border text-heading_color text-small2 lg:text-body_copy2 rounded-md  focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.zipCode
                              ? " border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("addBlock.enter_zip_code")}
                        />
                        {errors?.zipCode && (
                          <small className="text-state_color_error text-small3">
                            {errors?.zipCode.message}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="mt-10 lg:mt-[50px] text-center lg:text-end">
                      <button
                        type="submit"
                        className={`rounded-full w-full lg:w-fit lg:p-3 py-[6px] lg:pt-[13px] bg-main_color text-white  text-small3_b lg:text-small1_bold ${
                          subLoading
                            ? "opacity-70 lg:px-[46px]"
                            : "lg:px-[26px]"
                        }`}
                      >
                        {subLoading ? (
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                        ) : (
                          `${translate("addBlock.save_changes")}`
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <MobileBottomLogoutBtn />
    </>
  );
};

export default Account;
